import React from 'react';
import { withRouter } from "react-router";
import { Responsive, CreateButton, withTranslate, } from 'react-admin';
import { withStyles, Button, Link } from '@material-ui/core';

const styles = {
  button: {
    color: '#fff',
    backgroundColor: '#FF9200',
    '& svg': {
      display: 'none'
    },
    height: '36px',
    padding: '10px 30px',
    borderRadius: '2px',
  },
  smallButton: {
    width: '56px',
    height: '56px',
    padding: '0',
    minWidth: '0',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    borderRadius: '50%',
  }
};

export const CustomCreateButton = (props) => {
  const {
    classes,
    history,
    className,
    translate,
    customUrl,
    label='consent_solution_create',
    labelSmall='consent_solution_create_small',
    ...rest} = props


  return customUrl ? (
      <Responsive
        large={
          <Button
            className={`${classes.button} ${className}`}
            data-testid="create-new-consent-solution-button"
            variant="contained"
            onClick={()=>history.push(customUrl)}
            color="secondary">{translate(label)}</Button>
        }
        small={
          <Button
            label={labelSmall}
            className={`${classes.smallButton} ${className}`}
            onClick={()=>history.push(customUrl)}
            color="secondary">{translate(labelSmall)}</Button>
        }
      />
    )
    :
    (
      <Responsive
        large={
          <CreateButton
            {...rest}
            className={`${classes.button} ${className}`}
            data-testid="create-new-consent-solution-button"
            variant="contained"
            label={label}
            color="secondary"/>
        }
        small={
          <CreateButton
            {...rest}
            label={labelSmall}
            className={`${classes.smallButton} ${className}`}
            color="secondary"/>
        }
      />
  )
};


export default withStyles(styles)(withTranslate(withRouter(CustomCreateButton)))
